<template>
  <div class="card">
      <b-field>
        <b-input
          :placeholder="$t('meeting.chercher_meeting')"
          @input="search()"
          type="search"
          icon="magnify"
          v-model="search_query"
        ></b-input>
      </b-field>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  computed: {
    search_query: {
      get: function () {
        return this.$store.state.meeting.search_query
      },
      set: function (newValue) {
        this.$store.commit(`UPDATE_SEARCH_QUERY_INPUT`, newValue)
      }
    }
  },
  methods: {
    search () {
      this.$store.commit('SEARCH', this.search_query)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/adminPage/components/SearchBar.vue